module.exports = __webpack_public_path__ + "images/konst.fc34cfa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/konst.jpg
// module id = 44ab291b
// module chunks = 6 16